export var translations = {
    de: {
        forwardBtnText: 'Weiter',
        forwardBtnSubText: 'kostenlos und unverbindlich',
        backwardBtnText: 'Zurück',
    },
};
